import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import FamilyFestPickupLocationAPI from '@infrastructure/family-fest-pickup-location-api';
export const FamilyFestGetAllPickupLocationsAsync = createAsyncThunk('FamilyFestPickupLocation/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await FamilyFestPickupLocationAPI.FamilyFestGetAllPickupLocations();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestGetPickupLocationsPaginatedAsync = createAsyncThunk('FamilyFestPickupLocation/getPaginated', async (request, { rejectWithValue }) => {
    try {
        const response = await FamilyFestPickupLocationAPI.FamilyFestGetPickupLocationsPaginated(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestGetTransportDashboardSummaryAsync = createAsyncThunk('FamilyFestPickupLocation/getDashboardSummary', async (request, { rejectWithValue }) => {
    try {
        const response = await FamilyFestPickupLocationAPI.FamilyFestGetTransportDashboardSummary(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestGetTransportDashboardTrendAsync = createAsyncThunk('FamilyFestPickupLocation/getDashboardTrend', async (request, { rejectWithValue }) => {
    try {
        const response = await FamilyFestPickupLocationAPI.FamilyFestGetTransportDashboardTrend(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestCreatePickupLocationAsync = createAsyncThunk('FamilyFestPickupLocation/create', async (request, { rejectWithValue }) => {
    try {
        const response = await FamilyFestPickupLocationAPI.FamilyFestCreatePickupLocation(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestUpdatePickupLocationAsync = createAsyncThunk('FamilyFestPickupLocation/update', async (request, { rejectWithValue }) => {
    try {
        const response = await FamilyFestPickupLocationAPI.FamilyFestUpdatePickupLocation(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestDeletePickupLocationAsync = createAsyncThunk('FamilyFestPickupLocation/delete', async (id, { rejectWithValue }) => {
    try {
        await FamilyFestPickupLocationAPI.FamilyFestDeletePickupLocation(id);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestClosePickupLocationAsync = createAsyncThunk('FamilyFestPickupLocation/close', async (request, { rejectWithValue }) => {
    try {
        const response = await FamilyFestPickupLocationAPI.FamilyFestClosePickupLocation(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestGetPickupLocationsNotPaginatedAsync = createAsyncThunk('FamilyFestPickupLocation/getNotPaginated', async (request, { rejectWithValue }) => {
    try {
        const response = await FamilyFestPickupLocationAPI.FamilyFestGetPickupLocationsNotPaginated(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFamilyFestPickupLocationByIdAsync = createAsyncThunk('FamilyFestPickupLocation/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await FamilyFestPickupLocationAPI.FamilyFestGetPickupLocationById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadFamilyFestRouteInformationExcelAsync = createAsyncThunk('FamilyFestPickupLocation/downloadRouteExcel', async (eventId, { rejectWithValue }) => {
    try {
        await FamilyFestPickupLocationAPI.downloadFamilyFestRouteInformationExcel(eventId);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadFamilyFestPickupLocationAttendeesExcelAsync = createAsyncThunk('FamilyFestPickupLocation/downloadPickupLocationAttendeesExcel', async ({ pickupLocationId }, { rejectWithValue }) => {
    try {
        await FamilyFestPickupLocationAPI.downloadFamilyFestPickupLocationAttendeesExcel(pickupLocationId);
    }
    catch (error) {
        if (error instanceof Error) {
            return rejectWithValue({ error: error.message, status: 400 });
        }
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadFamilyFestPickupLocationsExcelAsync = createAsyncThunk('FamilyFestPickupLocation/downloadPickupLocationsExcel', async (eventId, { rejectWithValue }) => {
    try {
        await FamilyFestPickupLocationAPI.downloadFamilyFestPickupLocationsExcel(eventId);
    }
    catch (error) {
        if (error instanceof Error) {
            return rejectWithValue({ error: error.message, status: 400 });
        }
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadFamilyFestPickupLocationCoordinatorsExcelAsync = createAsyncThunk('FamilyFestPickupLocation/downloadPickupLocationCoordinatorsExcel', async (eventId, { rejectWithValue }) => {
    try {
        await FamilyFestPickupLocationAPI.downloadFamilyFestPickupLocationCoordinatorsExcel(eventId);
    }
    catch (error) {
        if (error instanceof Error) {
            return rejectWithValue({ error: error.message, status: 400 });
        }
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestAssignCoordinatorAsync = createAsyncThunk('FamilyFestPickupLocation/assignCoordinator', async ({ assignmentId, pickupLocationId }, { rejectWithValue }) => {
    try {
        await FamilyFestPickupLocationAPI.FamilyFestAssignCoordinator(assignmentId, pickupLocationId);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const FamilyFestUnassignCoordinatorAsync = createAsyncThunk('FamilyFestPickupLocation/unassignCoordinator', async ({ assignmentId, pickupLocationId }, { rejectWithValue }) => {
    try {
        await FamilyFestPickupLocationAPI.FamilyFestUnassignCoordinator(assignmentId, pickupLocationId);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
